import { createFileRoute } from "@tanstack/react-router";
import { catalogDogRoute } from "@/app-clients/catalog-detail/dog-route-data";
import { ListingRouteComponent } from "@/app-clients/catalog-detail/dog-route";
import { DogRouteNotFound } from "@/app-clients/catalog-detail/dog-route-not-found";

export const Route = createFileRoute("/_find/dog/$dogId")({
    loader: catalogDogRoute.loader,
    head: catalogDogRoute.head,
    component: ListingRouteComponent,
    notFoundComponent: DogRouteNotFound,
});
